import {
	Button,
	Heading,
	Image,
	View,
	useAuthenticator,
	useTheme,
} from '@aws-amplify/ui-react';

export const formFields = {
	signIn: {
		username: {
			placeholder: 'Enter your email',
		},
		password: {
			placeholder: 'Enter your password',
		},
	},
	forgotPassword: {
		username: {
			placeholder: 'Enter your email',
		},
	},
};

export const components = {
	Header() {
		const { tokens } = useTheme();

		return (
			<View textAlign="center" padding={tokens.space.large}>
				<Image
					alt="Customer Dynamics logo"
					src="https://images.squarespace-cdn.com/content/v1/6321facc7e681a5a6cd5d9b9/6c844dce-2a1e-4852-a864-9486a500ff90/Horizontal+Velocity++updated.png?format=1000w"
				/>
			</View>
		);
	},

	SignIn: {
		Header() {
			const { tokens } = useTheme();

			return (
				<Heading
					padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
					level={3}
				>
					Sign In
				</Heading>
			);
		},
		Footer() {
			const { toForgotPassword } = useAuthenticator();

			return (
				<View textAlign="center">
					<Button
						fontWeight="normal"
						onClick={toForgotPassword}
						size="small"
						variation="link"
						marginBottom={30}
					>
						Reset Password
					</Button>
				</View>
			);
		},
	},
};
